import React from 'react';
import Beneficio from './extras/Beneficio';

const dinero = {
	img: './img/dinero.svg',
	imgalt: 'ahorre dinero',
	title: 'Ahorre Dinero',
	parrafo: 'Manejamos los mejores precios del mercado en el país',
};
const tiempo = {
	img: './img/time.svg',
	imgalt: 'ahorre tiempo',
	title: 'Ahorre Tiempo',
	parrafo: 'Lleve a cabo trabajos más exigentes en menos tiempo y con precisión!',
};
const partes = {
	img: './img/tools.svg',
	imgalt: 'partes premium',
	title: 'Partes Premium',
	parrafo: 'Nos intereza mucho la satisfacción de nuestros clientes, por lo que usamos los mejores componentes',
};

const Beneficios = () => {
	return (
		<section className='beneficios' id='benefits'>
			<div className='beneficios__container'>
				<h2 className='beneficios__title'>Beneficios</h2>

				<div className='beneficios__items'>
					<Beneficio datos={dinero} />
					<Beneficio datos={tiempo} />
					<Beneficio datos={partes} />
				</div>
			</div>
		</section>
	);
};

export default Beneficios;
